






import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { MetaInfo } from 'vue-meta';

import LocaleMixin from '@/mixins/locale';

@Component({
  metaInfo(this: App): MetaInfo {
    return {
      title: 'Game Portal',
      htmlAttrs: {
        lang: this.locale,
      },
    };
  },
})
export default class App extends mixins(LocaleMixin) {}
